interface SectionHeadProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHead({
  eyebrow,
  title,
  desc,
  align = 'left',
}: SectionHeadProps) {
  return (
    <div
      className={
        align === 'center'
          ? 'mx-auto flex max-w-2xl flex-col items-center text-center'
          : 'flex max-w-2xl flex-col items-start'
      }
    >
      <span className="inline-flex items-center gap-2 text-[12px] font-semibold tracking-[0.24em] text-[#b3873a]">
        <span className="h-px w-5 bg-[#c8a45f]" aria-hidden="true" />
        {eyebrow}
      </span>
      <h2 className="mt-3 font-song text-[26px] font-semibold leading-tight text-[#241f18] md:text-[34px]">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-[15px] leading-relaxed text-[#6d6149]">{desc}</p>
      )}
    </div>
  );
}